import { React } from "react";
import {
	Checkbox,
	Chip,
	FormControlLabel,
	InputAdornment,
	TextField,
	useMediaQuery
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import MatchPlayersStyles from "../styles/MatchPlayers.styles";
import PlayerFormat from "../../../util/player-format";

const MatchPlayers = ({
	team,
	currentPlayers = [],
	singlePlayers = [],
	doublesPlayers = [],
	isSingle,
	onChange,
	startAdornment
}) => {
	const firstInitial = useMediaQuery("(max-width:1180px)");
	const classes = MatchPlayersStyles({
		twoSelected: currentPlayers.length === 2
	});

	const hiddenUniforms = [PlayerFormat.TeamUniform];

	/**
	 * Determine if the parameter player has it's starter flag toggled or if the uniform matches the NotSpecifiedUniform
	 * @param {{starter?:boolean, uniform?: string | number}} player
	 * @returns
	 */
	const resolveStarterOrNA = ({ starter, uniform }) =>
		starter || uniform === PlayerFormat.NotSpecifiedUniform;

	const resolveSinglePlayer = (players) => {
		const [resolved] = singlePlayers.filter((p) => p.id === players[0]);

		return resolved || null;
	};

	const sortPlayers = (a, b) => {
		if (
			a.uniform === PlayerFormat.NotSpecifiedUniform ||
			a.firstName < b.firstName
		)
			return -1;
		if (a.firstName > b.firstName) return 1;
		return 0;
	};

	return isSingle ? (
		<Autocomplete
			label={team.teamName}
			placeholder={team.teamName}
			value={resolveSinglePlayer(currentPlayers)}
			onChange={(e, value) => onChange(value ? [value.id] : [])}
			options={singlePlayers
				.filter(
					(player) =>
						!hiddenUniforms.some((uniform) => uniform === player.uniform) &&
						resolveStarterOrNA(player)
				)
				.sort(sortPlayers)}
			getOptionLabel={(player) =>
				PlayerFormat.resolveTennisPlayerName(player, firstInitial)
			}
			renderInput={(params) => (
				<TextField
					{...params}
					variant="outlined"
					label={team.teamName}
					placeholder={team.teamName}
					InputProps={{
						...params.InputProps,
						startAdornment: startAdornment && (
							<InputAdornment position="start">{startAdornment}</InputAdornment>
						)
					}}
				/>
			)}
			getOptionSelected={(option, value) => {
				return option.id === value.id;
			}}
			className={classes.players}
		/>
	) : (
		<Autocomplete
			value={doublesPlayers.filter((p) => currentPlayers.includes(p.id))}
			onChange={(e, value) => onChange(value.map((p) => p.id))}
			options={doublesPlayers
				.filter(
					(player) =>
						!hiddenUniforms.some((uniform) => uniform === player.uniform) &&
						resolveStarterOrNA(player)
				)
				.sort(sortPlayers)}
			getOptionLabel={(player) =>
				PlayerFormat.resolveTennisPlayerName(player, firstInitial)
			}
			getOptionDisabled={() => currentPlayers.length > 1}
			renderInput={(params) => (
				<TextField
					{...params}
					variant="outlined"
					label={team.teamName}
					InputProps={{
						...params.InputProps,
						startAdornment: (
							<>
								{startAdornment && (
									<InputAdornment position="start">{startAdornment}</InputAdornment>
								)}
								{params.InputProps.startAdornment}
							</>
						)
					}}
				/>
			)}
			renderOption={(p, { selected }) => (
				<FormControlLabel
					control={<Checkbox color="primary" size="small" checked={selected} />}
					label={PlayerFormat.resolveTennisPlayerName(p, firstInitial)}
				/>
			)}
			renderTags={(tagValue, getTagProps) =>
				tagValue.map((option, index) => (
					<Chip
						label={PlayerFormat.resolveTennisPlayerName(option, firstInitial)}
						{...getTagProps({ index })}
						className={classes.chip}
					/>
				))
			}
			limitTags={2}
			multiple
			disableCloseOnSelect
			className={classes.players}
		/>
	);
};

export default MatchPlayers;
